/**
 * API base URLs, in one place.
 *
 * ## Why the version prefix belongs in the base URL
 *
 * api-edna serves its application routes beneath `/v1`. The front end's ~47
 * per-request paths carry no prefix, so the base URL absorbs the difference and
 * none of those paths had to change at cutover.
 *
 * ## Why `/healthz` is separate
 *
 * Health sits **outside** the version prefix — `/healthz` answers 200, while
 * `/v1/healthz` is a 404. Appending `/healthz` to the base URL therefore reports a
 * healthy API as down. Use `healthOrigin()` instead of string-concatenating onto
 * the base URL.
 *
 * ## Why a module rather than inline literals
 *
 * The local URL was previously duplicated across eight call sites, which is why
 * adding `/v1` was an eight-file change rather than a one-line one.
 */

/** Local development target. Matches api-edna's docker-compose port. */
export const LOCAL_API_URL = 'http://localhost:8000/v1';

/**
 * Strip the version prefix from a base URL to get the origin health lives on.
 *
 * Tolerates a trailing slash and a base URL that has no prefix, so it is safe to
 * call on any configured target.
 */
export function healthOrigin(apiUrl: string): string {
  return apiUrl.replace(/\/v\d+\/?$/, '');
}
